export * from './juchuno.pipe';
export * from './zipcode.pipe';
export * from './numeric.pipe';
export * from './null2bar.pipe';
export * from './date.pipe';
export * from './hour.pipe';
export * from './html.pipe';



// WEBPACK FOOTER //
// ./src/app/modules/shared/pipes/index.ts